jQuery.noConflict();

(function ($) {
    var image = $('.jarallax-img');
    if (!image) return;

    var options = {
        disableParallax: /iPad|iPhone|iPod|Android/,
        disableVideo: /iPad|iPhone|iPod|Android/,
        speed: 0.1,
    };

    image.imagesLoaded(function () {
        image.parent().jarallax(options).addClass('initialized');
    });
})(jQuery);

(function ($) {
    'use strict';
    $('.featured-posts').owlCarousel({
        dots: false,
        margin: 30,
        nav: true,
        navText: [
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="currentColor"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        responsive: {
            0: {
                items: 1,
                slideBy: 1,
            },
            768: {
                items: 3,
                slideBy: 3,
            },
            992: {
                items: 4,
                slideBy: 4,
            },
        },
    });
})(jQuery);

document.addEventListener('DOMContentLoaded', function () {
    function showModal(modalId) {
        const modal = document.getElementById(modalId);
        modal.style.display = 'block';

        modal.querySelector('.close-button').addEventListener('click', function () {
            modal.style.display = 'none';
        });

        window.addEventListener('click', function (event) {
            if (event.target === modal) {
                modal.style.display = 'none';
            }
        });
    }

    function getQueryParams() {
        const params = {};
        const parser = document.createElement('a');
        parser.href = window.location.href;
        const query = parser.search.substring(1);
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
        return params;
    }

    function removeQueryParams() {
        if (window.history.pushState) {
            const baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.pushState({ path: baseUrl }, '', baseUrl);
        }
    }

    const form = document.querySelector('form[data-members-form]');
    if (form) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.attributeName === 'class' && form.classList.contains('success')) {
                    showModal('successModal');
                }

                if (mutation.attributeName === 'class') {
                    const hasSuccessOrLoading = form.classList.contains('success') || form.classList.contains('loading');
                    // Select the button and input within the form
                    const button = form.querySelector('.playBtn');
                    const input = form.querySelector('input[data-members-email]');

                    // Enable or disable the button and input based on the form's class
                    button.disabled = hasSuccessOrLoading;
                    input.disabled = hasSuccessOrLoading;

                    if (form.classList.contains('success')) {
                        // Assuming showModal is a function to display your modal
                        showModal('successModal');
                    }
                }
            });
        });

        observer.observe(form, {
            attributes: true
        });
    }

    const queryParams = getQueryParams();
    if (queryParams.action === 'subscribe' && queryParams.success === 'true') {
        showModal('confirmModal');
        removeQueryParams();
    }
});